import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Training/Dashboard.js";
import Training from "./pages/Training/Training.js";
import BookingPage from "./pages/Training/BookingPage.js";
import ProtectedRoute from "./pages/Training/ProtectedRoute.js";
import Home from "./pages/Training/Home.tsx";
import About from "./pages/Training/About.js";
import Contact from "./pages/Training/Contact.js";
import Mission from "./pages/Training/Mission.js";
import Products from "./pages/Training/Products.js";
import Accessories from "./pages/Training/Accessories.js";
import Services from "./pages/Training/Services.js";
import AdminLogin from "./components/AdminLogin.js";
import AdminDashboard from "./components/AdminDashboard.js";
import Environmental from "./pages/Training/General Safety/Environmental.tsx";
import SafetyAwareness from "./pages/Training/General Safety/SafetyAwareness.tsx";
import Behaviour from "./pages/Training/General Safety/Behaviour.tsx";
import SConcepts from "./pages/Training/General Safety/SConcept.tsx";
import PPE from "./pages/Training/General Safety/PPE.tsx";
import LOTO from "./pages/Training/General Safety/LOTO.tsx";
import FirstAid from "./pages/Training/Health Safety/FirstAid.tsx";
import HeatColdStress from "./pages/Training/Health Safety/HeatColdStress.tsx";
import Mental from "./pages/Training/Health Safety/Mental.tsx";
import Crane from "./pages/Training/Warehouse Safety/Crane.tsx";
import Ergonomics from "./pages/Training/Health Safety/Ergonomics.tsx";
import Warehouse from "./pages/Training/Warehouse Safety/Warehouse.tsx";
import MHE from "./pages/Training/Warehouse Safety/MHE.tsx";
import Construction from "./pages/Training/Construction Safety/Construction.tsx";
import WorkingAtHeight from "./pages/Training/Construction Safety/WorkingAtHeight.tsx";
import Electrical from "./pages/Training/Electrical/Electrical.tsx";
import Chemical from "./pages/Training/Chemical Safety/Chemical.tsx";
import Road from "./pages/Training/Road Safety/Road.tsx";
import ISO14001 from "./pages/Training/ISO Training/ISO14001.tsx";
import ISO45001 from "./pages/Training/ISO Training/ISO45001.tsx";
import ISO9001 from "./pages/Training/ISO Training/ISO9001.tsx";
import ISO19011 from "./pages/Training/ISO Training/ISO19011.tsx";
import HIRA from "./pages/Training/ISO Training/HIRA.tsx";
import ISODocumentation from "./pages/Training/ISO Training/ISODocumentation.tsx";
import Emergency from "./pages/Training/Emegency Safety/Emergency.tsx";
import FireSafety from "./pages/Training/Emegency Safety/FireSafety.tsx";
import FeedbackForm from "./pages/FeedbackForm.js";
import LoginPage from "./pages/Training/LoginPage.js";
import ForgotPassword from "./pages/Training/ForgotPassword";
import ResetPassword from "./pages/Training/ResetPassword.js";
import Registration from "./pages/Training/Registration.js";
import CartPage from "./pages/Training/CartPage.js";
import ISO9K1 from "./pages/Audit/ISO9K1.jsx";
import ISO14K1 from "./pages/Audit/ISO14K1.jsx";
import ISO45K1 from "./pages/Audit/ISO45K1.jsx";
import OHSMS from "./pages/Audit/OHSMS.jsx";
import SafetyAssessment from "./pages/Audit/SafetyAssessment.jsx";
import SafetyLegalCompliance from "./pages/Compliance/SafetyLegalCompliance.jsx";
import ISO14K1Comp from "./pages/Compliance/ISO14K1Comp.jsx";
import ISO45K1Comp from "./pages/Compliance/ISO45K1Comp.jsx";
import SafetyLegislation from "./pages/Consultancy/SafetyLegislation.jsx";
import ISO9001Cons from "./pages/Consultancy/ISO9001Cons.jsx";
import ISO14001Cons from "./pages/Consultancy/ISO14001Cons.jsx";
import ISO45001Cons from "./pages/Consultancy/ISO45001Cons.jsx";
import RiskReduction from "./pages/Consultancy/RiskReduction.jsx";
import RCA from "./pages/Consultancy/RCA.jsx";

import CheckoutPage from "./pages/Training/CheckoutPage.js";
import PrivacyPolicy from "./pages/Training/PrivacyPolicy.js";
import TermsOfService from "./pages/Training/TermsOfService.js";
import { CartProvider } from "./pages/Training/CartContext.js";
import { AuthProvider } from "./context/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";

const App = () => {
  const [user, setUser] = useState(null);

  // ✅ Check if user is logged in
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="app-container">
            <Navbar />
            <div className="header-wrapper">
              <Header />
            </div>

            {/* Removed Firebase API Key display */}

            <main className="content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mission" element={<Mission />} />
                <Route path="/products" element={<Products />} />
                <Route path="/accessories" element={<Accessories />} />
                <Route path="/services" element={<Services />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<Registration />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />

                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/training" element={<Training />} />
                <Route path="/booking/:courseId" element={<BookingPage />} />
                <Route path="/training/general/environmental" element={<Environmental />} />
                <Route path="/training/general/safety-awareness" element={<SafetyAwareness />} />
                <Route path="/training/general/behaviour" element={<Behaviour />} />
                <Route path="/training/general/sconcepts" element={<SConcepts />} />
                <Route path="/training/general/PPE" element={<PPE />} />
                <Route path="/training/general/LOTO" element={<LOTO />} />
                <Route path="/training/health/firstaid" element={<FirstAid />} />
                <Route path="/training/health/heatcoldstress" element={<HeatColdStress />} />
                <Route path="/training/health/mental" element={<Mental />} />
                <Route path="/training/health/ergonomics" element={<Ergonomics />} />
                <Route path="/training/warehouse" element={<Warehouse />} />
                <Route path="/training/mhe" element={<MHE />} />
                <Route path="/training/constructionsafety" element={<Construction />} />
                <Route path="/training/workingatheight" element={<WorkingAtHeight />} />
                <Route path="/training/electrical" element={<Electrical />} />
                <Route path="/training/chemical" element={<Chemical />} />
                <Route path="/training/road" element={<Road />} />
                <Route path="/training/isotraining/iso14001" element={<ISO14001 />} />
                <Route path="/training/isotraining/iso45001" element={<ISO45001 />} />
                <Route path="/training/isotraining/iso9001" element={<ISO9001 />} />
                <Route path="/training/isotraining/iso19011" element={<ISO19011 />} />
                <Route path="/training/isotraining/hira" element={<HIRA />} />
                <Route path="/training/crane" element={<Crane />} />
                <Route path="/training/isotraining/isodocumentation" element={<ISODocumentation />} />
                <Route path="/training/emergency" element={<Emergency />} />
                <Route path="/training/firesafety" element={<FireSafety />} />
                <Route path="/register" ele ment={<Registration />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/feedback" element={<FeedbackForm />} />
                <Route path="/Audit/ISO9K1" element={<ISO9K1 />} />
                <Route path="/Audit/ISO14K1" element={<ISO14K1 />} />
                <Route path="/Audit/ISO45K1" element={<ISO45K1 />} />
                <Route path="/Audit/OHSMS" element={<OHSMS />} />
                <Route path="/Audit/SafetyAssessment" element={<SafetyAssessment />} />
                <Route path="/Compliance/SafetyLegalCompliance" element={<SafetyLegalCompliance />} />
                <Route path="/Compliance/ISO45001Comp" element={<ISO45K1Comp />} />
                <Route path="/Compliance/ISO14001Comp" element={<ISO14K1Comp />} />
                <Route path="/Consultancy/SafetyLegislation" element={<SafetyLegislation />} />
                <Route path="/Consultancy/ISO9001Cons" element={<ISO9001Cons />} />
                <Route path="/Consultancy/ISO14001Cons" element={<ISO14001Cons />} />
                <Route path="/Consultancy/ISO45001Cons" element={<ISO45001Cons />} />
                <Route path="/Consultancy/RiskReduction" element={<RiskReduction />} />
                <Route path="/Consultancy/RCA" element={<RCA />} />

                {/* Protected Routes */}
                <Route element={<ProtectedRoute user={user} />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                </Route>
              </Routes>
            </main>

            <Footer />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
